import React from 'react'

import 'app/components/common/list/list.scss'

type ListProps = {
  text: string
  markerStyle?: 'dashed' | 'bullet'
}

const List = ({ text, markerStyle }: ListProps) => {
  // Split string in array and filter empty strings
  const listItems = text
    .trim()
    .split('*--')
    .filter((el) => !!el)

  const listClassName = `list ${markerStyle ? `list--${markerStyle}` : ''}`

  return (
    <ul className={listClassName}>
      {listItems.map((item) => (
        <li key={item} className="list__item">
          {item}
        </li>
      ))}
    </ul>
  )
}

export default List
